import Vue from 'vue'
import Vuex from 'vuex'
import swal from 'sweetalert2'
import * as fb from '../firebase'
import router from '../router/index'
import { v4 as uuidv4 } from 'uuid'
import moment from "moment"


Vue.use(Vuex)

// realtime firebase
// fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
//     let postsArray = []

//     snapshot.forEach(doc => {
//         let post = doc.data()
//         post.id = doc.id

//         postsArray.push(post)
//     })

//     store.commit('setPosts', postsArray)
// })

// fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(snapshot => {
//     let postsArray = []

//     snapshot.forEach(doc => {
//         let post = doc.data()
//         post.id = doc.id

//         postsArray.push(post)
//     })

//     store.commit('setPosts', postsArray)
// })

function catchAlert(title, e, type) {
    let msg = ""
    switch (e.code) {
        case "auth/invalid-email":
            msg = "Por favor captura un email válido"
            break
        case "auth/wrong-password":
            msg = "Contraseña inválida"
            break
        case "auth/too-many-requests":
            msg = "Demasiados intentos fallidos, intenta más tarde o recupera tu contraseña"
            break
        case "auth/email-already-in-use":
            msg = "Este correo ya está dado de alta, recupera tu contraseña"
            break
        case "auth/user-not-found":
            msg = "Este usuario no existe en nuestros registros, crea una cuenta"
            break
        default:
            msg = "Hubo un error inesperado, por favor intenta de nuevo"
            break;
    }
    swal.fire(title, msg, type)
}

function sendAlert(title, msg, type) {

    swal.fire(title, msg, type)
}

function custom_sort(a, b) {
    return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
}

const store = new Vuex.Store({
    state: {
        overlay: false,
        loading: false,
        userProfile: {},
        posts: [],
        ticket: {
            id: null,
            puntos: null,
            time: null,
            time_txt: null,
            ini_time: null,
            fin_time: null
        },
        tickets: [],
        pregs: []
    },
    getters: {
        ticketID(state) {
            state.ticket.id = localStorage.getItem('id_ultimo_ticket')
            return state.ticket.id
        },
        timeInit(state) {
            state.ticket.ini_time = localStorage.getItem('ticket_ini_time')
            return state.ticket.ini_time
        },
        pregs(state) {
            state.pregs = JSON.parse(localStorage.getItem('pregs'))
            return state.pregs
        }
    },
    mutations: {
        showLoader(state, val) {
            state.loading = val
        },
        setUserProfile(state, val) {
            state.userProfile = val
        },
        setPerformingRequest(state, val) {
            state.performingRequest = val
        },
        setPosts(state, val) {
            state.posts = val
        },
        setTicketID(state, val) {
            localStorage.setItem('id_ultimo_ticket', val)
            state.ticket.id = val
        },
        setTimeInit(state, val) {
            if (localStorage.getItem('ticket_ini_time') == null || localStorage.getItem('ticket_ini_time') == '') {
                localStorage.setItem('ticket_ini_time', val)
                state.ticket.ini_time = val
            }
        },
        removeTimeInit(state, val = null) {
            localStorage.setItem('ticket_ini_time', '')
            localStorage.setItem('pregs', '')
            state.ticket.ini_time = ''
        },
        setTicket(state, data) {
            state.ticket.puntos = data.puntos
            state.ticket.time = data.time
            state.ticket.time_txt = data.time_txt
        },
        setTickets(state, data) {
            console.log('setting tickets')
            state.tickets = data
        },
        setPregs(state, data) {
            if (localStorage.getItem('pregs') == null || localStorage.getItem('pregs') == '') {
                localStorage.setItem('pregs', JSON.stringify(data))
                state.pregs = data
            }
        }
    },
    actions: {
        async login({ dispatch }, form) {
            // sign user in

            dispatch('showLoader', true)
            let user = {};

            try {
                user = await fb.auth.signInWithEmailAndPassword(form.email, form.password)
                console.log(user.user)
            } catch (e) {
                console.log({ e: e })
                catchAlert('Oops', e, 'warning')
            }

            dispatch('showLoader', false)

            if (Object.keys(user.user).length === 0 && user.user.constructor === Object)
                return

            //valida verificacion correo
            // // // console.log({ verified: user.user.emailVerified })
            // // // if (user.user.emailVerified == false) {
            // // //     sendAlert('Verifica tu correo', 'Aún no has verificado tu correo, ingresa al buzón del correo registrado y da clic en la liga de verificación.', 'warning')
            // // //     return
            // // // }


            // fetch user profile and set in state
            dispatch('fetchUserProfile', user.user)

            router.push('/')
        },
        async loginReportes({ dispatch }, form) {




        },
        async signup({ dispatch, commit }, form) {
            // sign user up
            dispatch('showLoader', true)
            let user = {}
            try {
                user = await fb.auth.createUserWithEmailAndPassword(form.email, form.password)
                console.log(user.user)
            } catch (e) {
                console.log({ e: e })
                catchAlert('Oops', e, 'warning')
                dispatch('showLoader', false)
            }


            if (Object.keys(user.user).length === 0 && user.user.constructor === Object)
                return

            // create user object in userCollections


            await fb.usersCollection.doc(user.user.uid).set({
                nombre: form.nombre,
                apellido: form.apellido,
                celular: form.celular,
                email: user.user.email,
                fecha_nacimiento: form.fecha_nacimiento,
                updated_at: ''
            })

            //user.user.sendEmailVerification();

            // //commit('setUserProfile', {})
            // await fb.auth.signOut()
            dispatch("logout");
            // // clear user data from state
            // commit('setUserProfile', {})

            sendAlert('¡Bien!', 'Hemos enviado un correo de verificación a la cuenta ' + form.email, 'success')
            dispatch('showLoader', false)

            // fetch user profile and set in state
            //dispatch('fetchUserProfile', user.user)
        },
        async registroMonedero({ dispatch, commit }, monedero) {
            // sign user up
            dispatch('showLoader', true)

            const userId = fb.auth.currentUser.uid

            await fb.usersCollection.doc(userId).update({
                monedero: monedero,
                updated_at: new Date()
            })


            dispatch('fetchUserProfile', { uid: userId })

            dispatch('showLoader', false)

            sendAlert('¡Bien!', 'Se ha registrado correctamente tu monedero.', 'success')
                // fetch user profile and set in state
                //dispatch('fetchUserProfile', user.user)
        },
        async fetchUserProfile({ commit }, user) {
            // fetch user profile
            const userProfile = await fb.usersCollection.doc(user.uid).get()
                //console.log({ user: userProfile.data() })
                // set user profile in state
            commit('setUserProfile', userProfile.data())

            // change route to dashboard

            // if (router.currentRoute.path === '/login') {
            //     router.push('/')
            // }
        },
        async logout({ commit }) {
            // log user out


            // clear user data from state
            //commit('setUserProfile', {})
            localStorage.removeItem('user_arreglalo');

            // redirect to login view
            router.push('/administrador/')
        },
        async logout_lector({ commit }) {
            // log user out


            // clear user data from state
            //commit('setUserProfile', {})
            localStorage.removeItem('user_arreglalo_lector');

            // redirect to login view
            router.push('/lector/')
        },
        async createPost({ state, commit }, post) {
            // create post in firebase
            await fb.postsCollection.add({
                createdOn: new Date(),
                content: post.content,
                userId: fb.auth.currentUser.uid,
                userName: state.userProfile.name,
                comments: 0,
                likes: 0
            })
        },
        async likePost({ commit }, post) {
            const userId = fb.auth.currentUser.uid
            const docId = `${userId}_${post.id}`

            // check if user has liked post
            const doc = await fb.likesCollection.doc(docId).get()
            if (doc.exists) { return }

            // create post
            await fb.likesCollection.doc(docId).set({
                postId: post.id,
                userId: userId
            })

            // update post likes count
            fb.postsCollection.doc(post.id).update({
                likes: post.likesCount + 1
            })
        },
        async updateProfile({ dispatch }, user) {
            const userId = fb.auth.currentUser.uid
                // update user object
            const userRef = await fb.usersCollection.doc(userId).update({
                name: user.name,
                title: user.title
            })

            dispatch('fetchUserProfile', { uid: userId })

            // update all posts by user
            const postDocs = await fb.postsCollection.where('userId', '==', userId).get()
            postDocs.forEach(doc => {
                fb.postsCollection.doc(doc.id).update({
                    userName: user.name
                })
            })

            // update all comments by user
            const commentDocs = await fb.commentsCollection.where('userId', '==', userId).get()
            commentDocs.forEach(doc => {
                fb.commentsCollection.doc(doc.id).update({
                    userName: user.name
                })
            })
        },
        async registraTrivia({ dispatch, commit }, data) {


            dispatch('showLoader', true)


            //localStorage.setItem('puntos', puntos)
            //localStorage.setItem('ultimo_tiempo', data.time_txt)

            await dispatch('cierraParticipacion', {
                puntos: data.puntos,
                fecha_fin: new Date(),
                time_txt: data.time_txt,
                time: data.time,
                respuestas: {},
                week: moment().week()
            })

            commit('setTicketID', '')
            commit('removeTimeInit', '')

            //dispatch('showLoader', false)

            console.log("redireccionando")

            router.push('/resultado')

        },
        async cierraParticipacion({ dispatch, commit }, data) {
            const userId = fb.auth.currentUser.uid

            console.log({ 'cierra participacion': this.getters.ticketID })
                //console.log(data)

            data.fecha_fin = new Date()
            data.ticketID = this.getters.ticketID

            //fb.functions.useFunctionsEmulator('http://localhost:5001')

            var cierraParticipacion = fb.functions.httpsCallable('cierraParticipacion');

            await cierraParticipacion(JSON.stringify(data)).then(function(result) {
                // Read result of the Cloud Function.
                console.log({ resultadoFire: result })
                    // ...
            });
            console.log('terminó guardado cierra participación')

            //commit('setTicket', data)



        },
        async registroTicket({ dispatch, commit }, data) {

            //TODO: cerrar los tickets que estén en status abierto, antes de capturar nuevo ticket

            dispatch('showLoader', true)

            commit('removeTimeInit', '')

            const userId = fb.auth.currentUser.uid

            console.log(data.file)

            let ticketImgUrl = await dispatch('uploadImage', data.file)

            console.log('imagen cargada')
            console.log({ imgurl: ticketImgUrl })

            const time = new Date()
            let ticket = await fb.ticketsCollection.add({
                created_on: time,
                ticket_img_url: ticketImgUrl,
                user_id: fb.auth.currentUser.uid,
                user_email: fb.auth.currentUser.email,
                no_sucursal: data.no_sucursal,
                no_transaccion: data.no_transaccion,
                status: 'abierto'
            })
            console.log({ ticket: ticket })

            console.log(ticket.id)
            commit('setTicketID', ticket.id)

            if (data.monedero != '') {
                await fb.usersCollection.doc(userId).update({
                    updated_at: time,
                    monedero: data.monedero
                })
            }

            dispatch('fetchUserProfile', { uid: userId })

            dispatch('showLoader', false)

            router.push('/dinamica')

        },
        async uploadImage({ dispatch }, file) {
            // File or Blob named mountains.jpg
            console.log('cargando imagen')
            const userId = fb.auth.currentUser.uid
            const idImagen = uuidv4()
            const nombreImagen = userId + '-' + idImagen + '.' + file.name.split('.').pop()

            const storageRef = fb.storage.ref(`tickets/${nombreImagen}`).put(file)

            let promesa = null
            promesa = () => {
                return new Promise((resolve, reject) => {
                    storageRef.on('state_changed',
                        snapshot => {
                            //this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
                        }, error => {
                            console.log(error.message)
                            reject(error.message)
                        },
                        () => {
                            storageRef.snapshot.ref.getDownloadURL().then((url) => {
                                //console.log({ url: url })
                                resolve(url)
                                    //this.picture =url;
                            });
                        }
                    )
                })
            }

            let downloadUrl = null
            try {
                downloadUrl = await promesa()
            } catch (err) {
                console.log(err)
                return null
            }

            console.log({ termino: downloadUrl })
                //dispatch('setImgUrl', downloadUrl)

            return downloadUrl
        },
        showLoader({ commit }, val) {
            commit('showLoader', val)
        },
        async getTickets({ dispatch, commit }) {

            dispatch('showLoader', true)
            console.log('getTickets')

            const userId = fb.auth.currentUser.uid
            let tickets = null
            try {

                let promesa = null
                promesa = () => {
                    return new Promise((resolve, reject) => {

                        fb.ticketsCollection.where('user_id', '==', userId).where('status', '==', 'cerrado').onSnapshot(snapshot => {
                            let postsArray = []

                            snapshot.forEach(doc => {
                                let post = doc.data()
                                post.id = doc.id
                                postsArray.push(post)
                            })


                            postsArray.sort(custom_sort)
                            console.log({ tickets_: postsArray })
                            store.commit('setTickets', postsArray)
                            resolve(postsArray)

                        })

                    })
                }

                tickets = await promesa()
                console.log('set already')

            } catch (err) {
                console.log(err)
            }



            dispatch('showLoader', false)
            return tickets

        },
        async setTimeInit({ commit }) {

            const data = {
                init_time: new Date(),
                ticketID: this.getters.ticketID
            }

            //fb.functions.useFunctionsEmulator('http://localhost:5001')
            var comienzaParticipacion = fb.functions.httpsCallable('comienzaParticipacion');

            let res = null
            await comienzaParticipacion(JSON.stringify(data)).then(function(result) {
                // Read result of the Cloud Function.
                console.log({ resultadoFire: result })
                res = result;
                // ...
            });
            console.log('comienza participación')
            console.log(res)
            if (res.data.status == 'notok' && res.data.time_init != '') {
                data.init_time = new Date(res.data.time_init)
            }

            commit('setTimeInit', data.init_time)
        }

    }
})

export default store